<template>
    <div class="container">
        <div class="div_top">
            <div class="div_my">
                <div style="flex: 1"></div>
                <img class="img_button" src="./imgs/button_my.png" @click="goMy" />
            </div>

            <div class="div_rule">
                <img class="img_button" src="./imgs/button_rule.png" @click="goRule" />
            </div>

            <div class="div_button">
            </div>
        </div>

        <div class="div_bottom">
            <div class="div_round">
            </div>

            <div style="display: flex; flex: 1;"></div>
            <div class="div_list">
            </div>
        </div>


        <div class="div_gift_three">
        </div>
    </div>
</template>


<script>
import http from '../../common/api';

const BG_TOP = 'https://app-1301744297.file.myqcloud.com/event/qixi_bg_top.png';
const BG_BOTTOM = 'https://app-1301744297.file.myqcloud.com/event/qixi_bg_bottom.png';

export default ({
    data() {
        return {
            id: -1,
            gender: -1,
            token: ''
        }
    },

    created() {
        console.log('can it be created si- - - - - - - >');
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
            } catch(e) {}
        },

        click(page) {
            // alert(this.token);
            // console.log('tiktok tiktok really - - - - - - >', this.token);
            // return;
            const p = {};
            // p.page = 'FreeChat';
            p.page = page;
            p.id = '214791';
            p.data = {};
            // p.tt = this.id;
            // p.hh = this.gender;
            const z = JSON.stringify(p);
            window.ReactNativeWebView.postMessage(z);
        },

        action() {
            // fetch('https://api.apiopen.top/api/sentences').then(cb => {
            //     console.log('cb si this -- -  -- ->',  global.stt, cb);
            // })

            const p = { act_code: 'qixi2022' };
            const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjIxNDYwOSwiZ2VuZGVyIjoxLCJleHAiOjE2NTg5MTQ1MTF9.NO6G3PctY3n0B44pw9cnJPV0pKy8PJ2cdVVw62wEF44';
            http.get('activity/mainpage', p, token).then(cb => {
                // console.log('res res res -- -  -- ->', cb);
                alert(cb.start_time);
            }).catch(err => {
                console.log('err err err - - - - - ->', err);
            })
        },

        goMy() {
            console.log('log log err - - - - - ->');
        },

        goRule() {  // 跳转到活动规则页面
            window.location.href = '/event-qixi-rule';
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    /* padding-bottom: 40px; */
    align-items: center;
    background-color: #FFF;
    flex-direction: column;
    justify-content: center;
}
.button {
    width: 100px;
    height: 80px;
    margin-top: 40px;
    border: 1px solid gold;
}

.div_top {
    width: 100vw;
    height: 214.8vw;
    background-image: url('https://app-1301744297.file.myqcloud.com/event/qixi_bg_ttop.png');
    background-size: contain;
    display: flex;
    flex-direction: column;
}
.div_bottom {
    width: 100vw;
    height: 286.5vw;
    background-image: url('https://app-1301744297.file.myqcloud.com/event/qixi_bg_bottom.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-color: green;
    display: flex;
    flex-direction: column;
}

.div_my {
    display: flex;
    width: 100vw;
    height: 10vw;
    /* background-color: green; */
    margin-top: 40vw;
}
.img_button {
    width: 30vw;
}

.div_rule {
    display: flex;
    width: 100vw;
    height: 10vw;
    margin-top: 4vw;
}
.div_button {
    width: 80vw;
    height: 12.5vw;
    background-image: url(./imgs/button_top.png);
    align-self: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 76vw;
}

.div_gift_three {
    position: absolute;
    top: 164vw;
    width: 96vw;
    height: 80vw;
    /* flex: 1; */
    background-image: url(./imgs/bg_gift_three.png);
    align-self: center;
    background-size: contain;
    background-repeat: no-repeat;
}
.div_round {
    width: 96vw;
    height: 190vw;
    margin-top: 34vw;
    background-image: url(./imgs/bg_round.png);
    align-self: center;
    background-size: contain;
    background-repeat: no-repeat;
    /* background-color: pink; */
}
.div_list {
    width: 96vw;
    height: 62vw;
    /* margin-top: 140px; */
    background-image: url(./imgs/bg_bottom.png);
    align-self: center;
    background-size: contain;
    background-repeat: no-repeat;
    /* background-color: yellow; */
}
</style>